import { Link } from 'react-router-dom';
import cx from 'classnames';
import styles from './ParentalConsentWarning.module.scss';
import libraryStyles from '../../SCSS/Library.module.scss';

interface Props {
  moreStyles?: string;
}
const ParentalConsentWarning = ({ moreStyles }: Props) => {
  return (
    <div className={cx(styles.parentalConsentWarning, moreStyles)}>
      <p>
        By creating student accounts, you acknowledge that you have obtained parental consent for Peekapak to store and
        process students’ data on your behalf on the Peakapak learning platform. This is usually done through a school-
        or district-wide acceptable use policy agreement that parents sign. To review the types of data we store, please
        see our{' '}
        <Link to='/privacyPolicy' className={libraryStyles.textLink}>
          privacy policy
        </Link>
        .
      </p>
    </div>
  );
};

export default ParentalConsentWarning;
